import type React from 'react'

import { styled } from '@mui/material/styles'

interface FormProps {
  children: React.ReactNode
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  className?: string
}

const Form = styled(({
  onSubmit,
  children,
  ...props
}: FormProps) => <form onSubmit={onSubmit} {...props}>{children}</form>)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.sizes.spacing['04'],
  alignSelf: 'stretch',
  alignItems: 'flex-start',
}))

export default Form
export type { FormProps }
